import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { PacoteCampanhaFilter } from '../filter';
import { PacoteCampanhaSearch, PacoteCampanhaSearchTotal } from '../pacote-campanha-search';

@Injectable({
    providedIn: 'root'
})
export class PacoteCampanhaSearchHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/pacotecampanha`;
    }


    /** Realizada a pesquisa os pacotes de campanhas */
    search(filter: PacoteCampanhaFilter, orderBy: number, orderByDir: string, limit: number, offset: number): Observable<PacoteCampanhaSearch[]> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }
        // Order By
        params = params.append('orderBy', orderBy ? orderBy.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);
        // Limit
        params = params.append('limit', limit ? limit.toString() : null);
        // Offset
        params = params.append('offset', offset ? offset.toString() : null);

        return this.customHttp.get<PacoteCampanhaSearch[]>(this.pathApi, {params});
    }

    /** Obtem os totais da pesquisa dos pacotes de campanhas cadastrados */
    getTotais(filter: PacoteCampanhaFilter): Observable<PacoteCampanhaSearchTotal> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<PacoteCampanhaSearchTotal>(`${this.pathApi}/0/total`, {params});
    }
}
